
document.addEventListener("DOMContentLoaded", function () {
  const fadeInSection = document.querySelector(".js-fade-in");
  const fadeOutSection = document.querySelector(".js-fade-out");
  const historyBg = document.querySelector(".about-history-bg");
  const galleryInfos = document.querySelectorAll(".gallery-info"); // すべての gallery-info を取得
  const aboutSlogan = document.querySelector(".about-column__slogan"); // about-column__slogan を取得

  if (!fadeInSection || !fadeOutSection || !historyBg || galleryInfos.length === 0 || !aboutSlogan) return;

  function onScroll() {
    const fadeInRect = fadeInSection.getBoundingClientRect();
    const fadeOutRect = fadeOutSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (fadeInRect.top <= 200 && fadeOutRect.bottom >= windowHeight) {
      historyBg.classList.add("-active");

      // すべての gallery-info に -active を付与
      galleryInfos.forEach(gallery => gallery.classList.add("-active"));

      // about-column__slogan に -active を付与
      aboutSlogan.classList.add("-active");
    } else {
      historyBg.classList.remove("-active");

      // すべての gallery-info から -active を削除
      galleryInfos.forEach(gallery => gallery.classList.remove("-active"));

      // about-column__slogan から -active を削除
      aboutSlogan.classList.remove("-active");
    }
  }

  window.addEventListener("scroll", onScroll);
  onScroll(); // 初回実行
});



document.addEventListener("DOMContentLoaded", function () {
  const historyContainer = document.querySelector(".js-opacity-img");
  const historyBg = document.querySelector(".about-history-bg__img");

  if (!historyContainer || !historyBg) return;

  const offsetRem = 70; // offset の値を rem 単位で設定
  const offset = offsetRem * parseFloat(getComputedStyle(document.documentElement).fontSize); // rem をピクセルに変換

  function onScroll() {
    const rect = historyContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // js-opacity-img の bottom が画面の下端 + offset に到達したら -active を付与
    if (rect.bottom <= windowHeight + offset) {
      historyBg.classList.add("-active");
    } else {
      historyBg.classList.remove("-active");
    }
  }

  window.addEventListener("scroll", onScroll);
  onScroll(); // 初回実行
});
